var _mask, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Loading 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 12"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_498_6753",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 38.8071 38.8071 50 25 50C11.1929 50 0 38.8071 0 25C0 11.1929 11.1929 0 25 0C38.8071 0 50 11.1929 50 25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_498_6753_clip_path)",
    "data-figma-skip-parse": "true",
    mask: "url(#path-1-inside-1_498_6753)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -0.025 0.025 0 25 25)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1280,
    y: -1280,
    width: 2560,
    height: 2560
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(63, 104, 236, 0) 0deg,rgba(63, 104, 236, 1) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 25C43 34.9411 34.9411 43 25 43V57C42.6731 57 57 42.6731 57 25H43ZM25 43C15.0589 43 7 34.9411 7 25H-7C-7 42.6731 7.32689 57 25 57V43ZM7 25C7 15.0589 15.0589 7 25 7V-7C7.32689 -7 -7 7.32689 -7 25H7ZM25 7C34.9411 7 43 15.0589 43 25H57C57 7.32689 42.6731 -7 25 -7V7Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.25081825256347656,\"g\":0.41109108924865723,\"b\":0.92918169498443604,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.25081825256347656,\"g\":0.41109108924865723,\"b\":0.92918169498443604,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.25081825256347656,\"g\":0.41109108924865723,\"b\":0.92918169498443604,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.25081825256347656,\"g\":0.41109108924865723,\"b\":0.92918169498443604,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":-5.8572768759767441e-14,\"m01\":50.0,\"m02\":5.8572768759767441e-14,\"m10\":-50.0,\"m11\":-6.4123883882893223e-14,\"m12\":50.0},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}",
    mask: "url(#path-1-inside-1_498_6753)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_498_6753_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 25C43 34.9411 34.9411 43 25 43V57C42.6731 57 57 42.6731 57 25H43ZM25 43C15.0589 43 7 34.9411 7 25H-7C-7 42.6731 7.32689 57 25 57V43ZM7 25C7 15.0589 15.0589 7 25 7V-7C7.32689 -7 -7 7.32689 -7 25H7ZM25 7C34.9411 7 43 15.0589 43 25H57C57 7.32689 42.6731 -7 25 -7V7Z",
    mask: "url(#path-1-inside-1_498_6753)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.6dbdc8cdbd03dff6ffb53229c3fb25df.svg";
export { ForwardRef as ReactComponent };